<router-outlet>
  <app-top-loader></app-top-loader>
</router-outlet>
